package br.com.texeratx.boardgametimeapp.data.model.match

import kotlinx.serialization.Serializable

@Serializable
data class MatchListItemDTO(
    val id: Long,
    val date: String,
    val duration: Int,
    val game: MatchGameDTO,
    val players: List<MatchPlayerDTO>,
    val clanExpansionIds: List<Long> = emptyList()
)

@Serializable
data class MatchGameDTO(
    val id: Long,
    val catalogGameId: Long? = null,
    val name: String,
    val imageUrl: String?
)

@Serializable
data class MatchPlayerDTO(
    val id: Long,
    val name: String,
    val nickname: String?,
    val imageUrl: String?,
    val points: Double
)
